import React, { useEffect } from 'react';
import 'twin.macro';
import useNotification from './useNotification';
import ButtonExternal from '@teetsh/app/src/components/Buttons/ExternalLink';

export function useQueryErrorNotification({
  isError,
  message,
  timeout,
  ctaButton,
}: {
  isError: boolean;
  message: string;
  timeout?: number;
  ctaButton?: {
    url: string;
    text: string;
  };
}) {
  const { notifyError } = useNotification();

  useEffect(() => {
    if (isError) {
      notifyError({
        title: message,
        actions: ctaButton ? (
          <ButtonExternal href={ctaButton.url} outlined small>
            {ctaButton.text}
          </ButtonExternal>
        ) : undefined,
        timeout,
      });
    }
  }, [isError, message, ctaButton, timeout]);
}
